<div  class="usuaris-content">
  <div class="mdl-grid mdl-grid--no-spacing">
    <h5 class="mdl-layout-title mdl-cell--8-col">
      {{'DEFAULT_USUARI' | translate}}
      	<span ng-if ="ctrl.usuari.confirmat && !ctrl.usuari.deleted" >{{'USUARI_CONFIRMAT_HEADER' | translate}}	</span>
		<span ng-if ="(ctrl.usuari.deleted || ctrl.usuari.fictici)" class="color-vermell">{{'USUARI_NO_REGISTRAT_HEADER' | translate}}</span>
        <span ng-if ="(!ctrl.usuari.deleted && !ctrl.usuari.fictici && !ctrl.usuari.confirmat)" class="color-groc">
        {{'USUARI_NO_CONFIRMAT_HEADER' | translate}}</span>
</h5>
    <div class="mdl-cell mdl-cell--4-col">
      <div class="itec-float-right">
	      <button class="mdl-button mdl-js-button mdl-button--icon mdl-button--colored itec-float-right"
						ng-if="$root.permisos.ESBORRARUSUARI.delete"
	          itec-dialog-confirm
	          itec-dialog-confirm-title="{{'DEFAULT_TITOL_CONFIRMACIO_ESBORRAR' | translate}}"
	          itec-dialog-confirm-text-content="{{'USUARI_DELETE_CONTENT' | translate}}"
	          itec-dialog-confirm-text-ok="DIALOG_CONFIRM"
	          itec-dialog-confirm-text-cancel="DIALOG_CANCEL"
	          itec-dialog-confirm-function-ok="ctrl.deleteElem()">
	        <i class="material-icons">delete</i>
	      </button>
	      <button class="mdl-button mdl-js-button mdl-button--icon mdl-button--colored itec-float-right"
								ng-if="$root.permisos.ACTUALITZARUSUARI.edit"
								ng-click="ctrl.changeToForm()">
	        <i class="material-icons">edit</i>
	      </button>
      </div>
    </div>
  </div>



   <div class="mdl-cell--12-col">
      <md-card>
        <md-card-content>
          <div class="mdl-grid mdl-grid--no-spacing">
				<div class="mdl-cell mdl-cell--2-col">
	              <span>{{'DEFAULT_USERNAME' | translate}}:</span>
	            </div>
	            <div class="mdl-cell mdl-cell--10-col">
 					<span class="bold {{(ctrl.usuari.deleted || ctrl.usuari.fictici) ? 'color-vermell' : ''}}
                     {{(!ctrl.usuari.deleted && !ctrl.usuari.fictici && !ctrl.usuari.confirmat) ? 'color-groc' : ''}} ">
                    {{ctrl.usuari.username}}
                
                	</span>
	            </div>
	            <div class="mdl-cell mdl-cell--2-col">
	              <span>{{'DEFAULT_NOM' | translate}}:</span>
	            </div>
	            <div class="mdl-cell mdl-cell--10-col">
	              <span class="bold">{{ctrl.usuari.nom}}</span>
	            </div>

	            <div class="mdl-cell mdl-cell--2-col">
	              <span>{{'DEFAULT_COGNOM' | translate}}:</span>
	            </div>
	            <div class="mdl-cell mdl-cell--10-col">
	              <span class="bold">{{ctrl.usuari.cognom}}</span>
	            </div>
				<div class="mdl-cell mdl-cell--2-col">
	              <span>{{'DEFAULT_IDIOMA' | translate}}:</span>
	            </div>
	            <div ng-if="ctrl.usuari.idioma==0"  class="mdl-cell mdl-cell--10-col">
	              <span class="bold">{{'DEFAULT_CATALA' | translate}}</span>
	            </div>
	            <div ng-if="ctrl.usuari.idioma==1"  class="mdl-cell mdl-cell--10-col">
	              <span class="bold">{{'DEFAULT_ESPANYOL' | translate}}</span>
	            </div>
	            <div ng-if="ctrl.usuari.idioma==2"  class="mdl-cell mdl-cell--10-col">
	              <span class="bold">{{'DEFAULT_ANGLES' | translate}}</span>
	            </div>
	            <div class="mdl-cell mdl-cell--2-col">
	              <span>{{'USUARI_INFOITEC' | translate}}:</span>
	            </div>
	            <div  class="mdl-cell mdl-cell--10-col">
	              <span  ng-if="ctrl.usuari.infoitec" class="bold">{{'DEFAULT_SI' | translate}}</span>
	              <span  ng-if="ctrl.usuari.infoitec==false" class="bold">{{'DEFAULT_NO' | translate}}</span>
	            </div>
				<div class="mdl-cell mdl-cell--2-col">
	              <span>{{'DEFAULT_DATA_ACCES' | translate}}:</span>
	            </div>
	            <div class="mdl-cell mdl-cell--10-col">
	              <span class="bold">{{ctrl.usuari.accesdata}}</span>
	            </div>

	            <div class="mdl-cell mdl-cell--2-col">
	              <span>{{'DEFAULT_IP_ACCES' | translate}}:</span>
	            </div>

	            <div class="mdl-cell mdl-cell--10-col">
	              <span class="bold">{{ctrl.usuari.accesip}}</span>
	            </div>
	            <div ng-if="$root.issuperadmin" class="mdl-cell mdl-cell--2-col">
	              <span>{{'DEFAULT_BLOQUEJAT' | translate}}:</span>
	            </div>
	            <div class="mdl-cell mdl-cell--10-col" ng-if="$root.issuperadmin">
	              <span  ng-if="ctrl.usuari.bloquejat" class="bold">{{'DEFAULT_SI' | translate}}
  					<button
			            <button class="mdl-button mdl-js-button mdl-button--icon mdl-button--colored"
			            ng-if="$root.issuperadmin"
			            ng-click="ctrl.unlock()"
			            ng-disabled= "!ctrl.usuari.bloquejat">
  	                    <i class="icon-check"></i>
			        </button>
	              </span>
	              <span  ng-if="ctrl.usuari.bloquejat==false" class="bold">{{'DEFAULT_NO' | translate}}</span>
	            </div>
 				<div ng-if="ctrl.usuari.deleted==true"  class="mdl-cell mdl-cell--12-col">
              		<span class="bold">{{'USUARI_BAIXA' | translate}}</span>
            	</div>

	            <div ng-if="ctrl.usuari.deleted==false" class="mdl-cell mdl-cell--2-col">
	              <span>{{'USUARI_REGISTRE' | translate}}:</span>
	            </div>
	            <div ng-if="ctrl.usuari.fictici==false && ctrl.usuari.deleted==false"  class="mdl-cell mdl-cell--10-col">
              		<span class="bold">{{'USUARI_REGISTRAT' | translate}}</span>
            	</div>
            	<div ng-if="ctrl.usuari.fictici==true  && ctrl.usuari.deleted==false"  class="mdl-cell mdl-cell--10-col">
              		<span class="bold">{{'USUARI_NO_REGISTRAT' | translate}}</span>
            	</div>


	            <div ng-if="ctrl.usuari.deleted==false" class="mdl-cell mdl-cell--2-col">
	              <span>{{'USUARI_CONFIRMACIO' | translate}}:</span>
	            </div>
	            <div ng-if="ctrl.usuari.confirmat==true && ctrl.usuari.deleted==false"   class="mdl-cell mdl-cell--10-col">
              		<span class="bold">{{'USUARI_CONFIRMAT' | translate}}</span>
            	</div>
            	<div ng-if="ctrl.usuari.confirmat==false && ctrl.usuari.deleted==false"  class="mdl-cell mdl-cell--10-col">
              		<span class="bold">{{'USUARI_NO_CONFIRMAT' | translate}}</span>
            	</div>
				<div  ng-if="ctrl.usuari.deleted==false" class="mdl-cell mdl-cell--2-col">
	              <span>{{'DEFAULT_ENTITATS' | translate}}:</span>
	            </div>

 				<div ng-if="ctrl.usuari.deleted==false" class="mdl-cell mdl-cell--10-col">
	              <span ng-repeat="entitat in ctrl.usuari.entitats" class="bold">
    				<a class="itec-link bold" ng-single-click="ctrl.viewProductesEntitat({{entitat.id}});">
	              	{{entitat.nom}} </a>&nbsp;
	              	<!-- <br/>   -->
	              </span>
	            </div>

  				<div  ng-if="ctrl.usuari.deleted==false" class="mdl-cell mdl-cell--2-col">
	              <span>{{'USUARI_PRODUCTES' | translate}}:</span>
	            </div>

   				<div ng-if="ctrl.usuari.deleted==false" class="mdl-cell mdl-cell--10-col">
   					<span ng-repeat="entitatrol in ctrl.usuari.entitatrols" class="bold">
					  <span ng-if="$root.issuperadmin" class="bold"> {{entitatrol.nomentitat}}<br></span>
  	              	  <span ng-if="!$root.issuperadmin" ng-repeat="rol in entitatrol.rols">
  	              	  	<span ng-if ="!rol.liccaducada">{{rol.nom}}<br/></span>
  	              	  </span>
  	              	  <span ng-if="$root.issuperadmin" ng-repeat="rol in entitatrol.rols" class="tcqi--margin-left-20">   		
  	              	  	<span class ="{{(rol.liccaducada) ? 'color-vermell' : '' }}">{{rol.nom}}</span>
	                      <span ng-if="$root.issuperadmin && rol.caducitat!=null" >- {{'DEFAULT_DATA_CADUCITAT' | translate}}: {{rol.caducitat | date:'dd/MM/yyyy'}}</span>
	                      <br>
	                      <span ng-if="$root.issuperadmin && rol.tokenDemoModel!=null" > 

	                      	<span ng-repeat="token in rol.tokenDemoModel">
		                      	{{'tipusclient_' + token.tipusclient | translate}}:   	{{'DEFAULT_DATA_RENOVACIO' | translate}}: 
		                      	<span ng-if="token.datarenovacio!=null">{{token.datarenovacio | date:'dd/MM/yyyy'}}</span>
														<span ng-if="token.datarenovacio==null">No utilitzat</span>
		                      			 - Consultes gratuites {{token.numdemos}} - consumides {{token.numdemos-token.numdemosrestants}} - disponibles {{token.numdemosrestants}} 

												        <button ng-if="$root.permisos.ACTUALITZARUSUARI.edit"

												            <button class="mdl-button mdl-js-button mdl-button--icon mdl-button--colored"
												            ng-if="$root.issuperadmin"
												            ng-click="ctrl.renew(token.idproducte,token.tipusclient,token.versio)"
												            ng-disabled= "token.datarenovacio==null">
												          <i class="icon-repeat-redo"></i>
												        </button>
												        <br>
												  </span>
									      </span>
                  </span>
              	</span>
            </div>
          </div>
          <div class="horizontal_separator"></div>
        </md-card-content>
      </md-card>
    </div>
</div>
